export default "__VITE_ASSET__8187ad07__"